/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { CoreConfigService } from '@xbaht/ui/core/services';
import {
  fadeInLeft,
  zoomIn,
  fadeIn,
} from '@xbaht/ui/core/animations/core.animation';

@Component({
  selector: 'xbaht-content',
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
  encapsulation: ViewEncapsulation.None,
  animations: [fadeInLeft, zoomIn, fadeIn],
  standalone: false
})
export class ContentComponent implements OnInit {
  public coreConfig: any;
  public animate: any;

  private _unsubscribe: Subject<void>;

  constructor(private _coreConfigService: CoreConfigService) {
    this._unsubscribe = new Subject<void>();
  }

  ngOnInit(): void {
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((config: any) => {
        this.coreConfig = config;
        this.animate = this.coreConfig.layout.animation;
      });
  }

  fadeInLeft(outlet: any) {
    // if (this.animate === 'fadeInLeft') {
    //   return outlet.activatedRouteData.animation;
    // }
    return null;
  }

  zoomIn(outlet: any) {
    // if (this.animate === 'zoomIn') {
    //   return outlet.activatedRouteData.animation;
    // }
    return null;
  }

  fadeIn(outlet: any) {
    // if (this.animate === 'fadeIn') {
    //   return outlet.activatedRouteData.animation;
    // }
    return null;
  }
}
